import { Button, Modal, Form, Input, message, Row, Col } from "antd";
import { useState } from "react";
import { BsCheck2Circle } from "react-icons/bs";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import getBase64 from "../../../../utils/getBase64";
import { handleUploadVehicleImage } from "../../../../api/vehicles";

export default function AddImage({
  isVisible,
  setVisible,
  selected,
  chassis,
}: any) {
  const queryClient = useQueryClient();
  const [isSelected, setIsSelected] = useState(false);
  const [selectedFile, setSelectedFile]: any = useState(null);
  const [form] = Form.useForm();

  const changeHandler = (event: any) => {
    setSelectedFile(event.target.files[0]);
    setIsSelected(true);
  };

  const { mutate, isLoading } = useMutation({
    mutationFn: handleUploadVehicleImage,
    onSuccess: () => {
      message.success("Uploaded Successfully");
      queryClient.invalidateQueries({ queryKey: ["vehicles", chassis] });
      setVisible(false);
      clearForm();
    },
    onError: () => {
      message.error("Something went wrong");
      clearForm();
    },
  });

  const onSubmit = async () => {
    const { description } = form.getFieldsValue();
    let base64 = null;

    if (selectedFile) {
      base64 = await getBase64(selectedFile);
    }

    const data = {
      location: selected?.location,
      description: description,
      isMain: selected?.isMain,
      image: base64,
    };
    await mutate({ data, chassis });
  };

  const clearForm = async () => {
    form.resetFields();
    setSelectedFile(null);
    setIsSelected(false);
  };

  return (
    <Modal
      open={isVisible}
      title={`${selected?.title} : Image  [ ${selected?.location} ]`}
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="AddImage"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="AddImage"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="description"
              label={"Description ( Optional )"}
              rules={[
                {
                  required: false,
                  message: "Please enter description",
                },
              ]}
            >
              <Input type="text" placeholder="Description" />
            </Form.Item>
          </Col>
        </Row>

        <div className="flex flex-col justify-center items-center bg-gray-100 h-32 rounded-md border">
          <div className="flex flex-col justify-center items-center">
            {isSelected ? (
              <div className="flex flex-col justify-center items-center">
                <BsCheck2Circle color={"#16a34a"} size={30} />
                <div className="text-gray-600 mt-2">Image Selected</div>
                <div className="text-gray-500">{selectedFile?.name}</div>
              </div>
            ) : (
              <Form.Item
                name="file"
                label="Upload Image"
                rules={[
                  {
                    required: false,
                    message: "Please select file",
                  },
                ]}
              >
                <Input
                  type="file"
                  placeholder="Image"
                  onChange={changeHandler}
                />
              </Form.Item>
            )}
          </div>
        </div>
      </Form>
    </Modal>
  );
}
